<template>
  <el-dialog :modal="false" title="" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" custom-class="dialog-s">
    <div class="content">
      <div class="txt01">
        <img src="@/assets/unlock-success.png" alt="">
        <p>解锁结果</p>
      </div>
      <div class="txt02">
        <p>成功数：{{haveBatch.succeeded}}</p>
        <p>失败数：{{haveBatch.failed}}(选中企业已被解锁或权益不足)</p>
      </div>
    </div>
    <div class="operateBtn">
      <el-button type="pure" size="small" w88 @click="dialogVisible = false">好的</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { unlockBatchTip } from '@/views/clue/api/newClueApi'
export default {
  data() {
    return {
      dialogVisible: false,
      tipTitle: '解锁前500企业',
      timer: null,
      haveBatch: {},
      unlock500: ''
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  destroyed() {
    clearInterval(this.timer)
    this.timer = null
  },
  mounted() {
  },
  methods: {
    tipTitleF(val) {
      this.tipTitle = val == 1 ? '解锁结果' : '解锁前500企业'
      this.unlock500 = val
      // this.getUnlockBatchTip()
    },
    stopSetInterval() {
      if (this.timer) {
        // console.log('timer', this.timer)
        window.clearInterval(this.timer)
        this.timer = null
      }
    },
    async getUnlockBatchTip() {
      this.stopSetInterval()
      const res = await unlockBatchTip()
      // console.log('循环')
      if (res.code == 200) {
        if (res.data.length > 0) {
          let num = 0
          res.data.forEach((v, index) => {
            if (v.isDone) {
              this.open(v.succeeded, v.failed)
            } else {
              num++
            }
          });

          if (num > 0) {
            this.stopSetInterval()
            this.timer = window.setInterval(() => {
              setTimeout(() => {
                console.log('isDone:false')
                this.getUnlockBatchTip()
              }, 0);
            }, 300000)
          } else {
            this.stopSetInterval()
            this.unlock500 = ''
          }
        } else {
          if (this.unlock500 == 2) {
            this.stopSetInterval()
            console.log('500-0')
            this.timer = window.setInterval(() => {
              setTimeout(() => {
                console.log('点击批量解锁500', this.unlock500)
                this.getUnlockBatchTip()
              }, 0);
            }, 300000)
          } else {
            window.clearInterval(this.timer)
            this.timer = null
          }
        }
      }
    },
    open(s, f, tit) {
      const h = this.$createElement;
      this.$msgbox({
        title: '',
        message: h('div', { class: 'content' }, [
          h('div', { class: 'txt01' }, [
            // h('img',null,''),
            h('p', null, this.tipTitle)
          ]),
          h('div', { class: 'txt02' }, [
            h('p', null, '成功数：' + s),
            h('p', null, '失败数：' + f + '(选中企业已被解锁或权益不足)'),
          ])
        ]),
        customClass: 'batchMsgbox',
        iconClass: 'el-icon-success',
        modal: false,
        closeOnClickModal: false,
        // showCancelButton: true,
        confirmButtonText: '好的',
        // cancelButtonText: '取消',
      }).then(action => {
      }).catch(() => {

      });
      setTimeout(() => {
        this.$msgbox.close()
      }, 5000)
    },

    handleClose(done) {
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  padding: 6px 22px 0px;
  box-sizing: border-box;
  .txt01 {
    text-align: center;
    img {
      width: 50px;
      height: 50px;
      display: block;
      margin: auto;
    }
    p {
      margin-top: 6px;
      margin-bottom: 8px;
      font-weight: bold;
      color: #333333;
      line-height: 20px;
      font-size: 18px;
      text-align: center;
    }
  }
  .txt02 {
    p {
      font-weight: 400;
      color: #666666;
      line-height: 19px;
    }
  }
}
.operateBtn {
  margin: 24px auto 12px;
  text-align: center;
}
::v-deep {
  .el-dialog__header {
    padding: 0;
  }
}
</style>
<style lang="scss">
.batchMsgbox {
  width: 350px;
  min-width: 350px;
  padding-bottom: 32px;
  .el-icon-success {
    position: relative;
    width: 50px;
    height: 50px;
    margin: auto;
    background: url(~@/assets/unlock-success.png) no-repeat center;
    background-size: 100%;
    display: block;
    top: unset;
    transform: translateY(0);
    &::before {
      content: "";
    }
  }
  .el-message-box__status + .el-message-box__message {
    padding: 0;
  }
  .el-message-box__btns {
    text-align: center;
    padding-top: 14px;
  }
}
</style>